export default "__VITE_ASSET__CazfL9rU__"